<template>
  <div class="message-bill">
    <!-- <div class="titileDefinition">短信账单</div> -->
    <!-- 筛选部分 -->
    <div class="section-right-content-box search-box" style=" padding: 0px">
      <div class="box-shadow top-box">
        <div class="global-title">短信账单</div>
      </div>
      <!-- 筛选部分 -->
      <div class="headForm" style="margin-top: 20px">
        <inputForm key="detail2" :inputData="inputData" :time="4" @toParentVal="searchForm" :btnPosition="true">
        </inputForm>
        <el-button @click="getphone()" type="primary" style="margin-bottom: 13px;margin-left: 50px;">导出</el-button>
      </div>
    </div>
    <div class="section-right-content-box">
      <!-- 表格部分 -->
      <div class="table-box">
        <el-table ref="multipleTable" :data="countTable" tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; opacity: 1" show-summary>
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="comfrom" label="发送类型" width="150px"></el-table-column>
          <el-table-column label="短信类型" width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.smsType == 0">普通短信</span>
              <span v-else-if="scope.row.smsType == 1">富信</span>
              <span v-else-if="scope.row.smsType == 2">卡片短信</span>
            </template>
          </el-table-column>
          <el-table-column prop="sendTotalNumber" label="发送总条数"></el-table-column>
          <el-table-column prop="smsTotalNumber" label="计费总条数"></el-table-column>
          <el-table-column prop="subTotalNumber" label="提交总条数"></el-table-column>
          <!-- <el-table-column prop="chinaMobileTotalNumber" label="移动号码"></el-table-column>
          <el-table-column prop="chinaUnicomTotalNumber" label="联通号码"></el-table-column>
          <el-table-column prop="chinaTelecomTotalNumber" label="电信号码"></el-table-column> -->
          <el-table-column prop="failTotalNumber" label="发送失败条数"></el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button size="small" type="text" class="operation" v-zoom='{ from: pageName, name: "查看发送明细" }'
                @click="handleCheck(scope.$index, scope.row)">查看发送明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 发送明细弹窗 -->
    <el-dialog title="发送明细" v-if="showDetail" :visible.sync="showDetail" width="70%" style="min-width: 1200px">
      <template slot="title">
        <span class="sendDetail">发送明细</span>
        <span :style="{ color: changeColor }">({{ typeValue2 }})</span>
      </template>
      <div class="show-detail-wrapper">
        <!-- 筛选部分 -->
        <div class="headForm">
          <inputForm key="detail" :inputData="inputData1" :time="5" :reset="reset" :defaultValue="defaultValue"
            @toParentVal="searchFormOne" :btnPosition="true"></inputForm>
        </div>
        <el-table :data="sendDetail" v-loading="tableLoading" tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; opacity: 1" show-summary>
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column property="statisticsTime" label="统计时间"></el-table-column>
          <el-table-column property="sendTotalNumber" label="发送总条数"></el-table-column>
          <el-table-column property="smsTotalNumber" label="计费总条数"></el-table-column>
          <el-table-column property="subTotalNumber" label="提交总条数"></el-table-column>
          <!-- <el-table-column property="chinaMobileTotalNumber" label="移动号码"></el-table-column>
          <el-table-column property="chinaUnicomTotalNumber" label="联通号码"></el-table-column>
          <el-table-column property="chinaTelecomTotalNumber" label="电信号码"></el-table-column> -->
          <el-table-column property="failTotalNumber" label="发送失败条数"></el-table-column>
        </el-table>
        <el-pagination background layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="sendDetailTotal"
          style="text-align: right; margin-top: 20px" @current-change="currentChange"
          @size-change="handleSizeChange"></el-pagination>
      </div>
    </el-dialog>



    <!-- Tag://  -->
    <el-dialog title="身份验证" width="600px" :show-close="false" custom-class="system-dialog" :visible.sync="visible"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input disabled placeholder="请输入..." v-model="phoneStr" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCode">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="downloadFileMessage()">
          确定
        </button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>

     <!-- 生成报表 -->
     <generate :control = 'control' 
                v-if="control" 
                @transData="(val) => (control = val)"
                @transData1 = 'getphone1'
                >
      </generate>
  </div>
</template>
<script>
import {
  shortTypes,
  totalSearch,
  sendDetail,
} from "@/api/backstage/messageBill";
var month = new Date();
var monthNum = month.getMonth() - 1;
var oneMonthAgo = month.setMonth(monthNum);
import inputForm from "../../components/inputForm";
import generate from '../../components/generate_report.vue'
import { querySellerSetting, getSellerCheckCode, getMessage_Zhangdang } from "@/api/downloadFile.js"
export default {
  name: "message-bill",
  data() {
    return {
      control:false,
      pageName: "后台管理-短信账单",
      pageNum: 1,
      pageSize: 10,
      tableLoading: false,
      reset: "1",
      defaultValue: [],
      inputData: [
        // 表单项
        {
          name: "发送类型:",
          val: "status",
          selectArr: [],
        },
        {
          name: "短信类型:",
          val: "smsType",
          selectArr: [
            {
              id: "",
              label: "全部"
            },
            {
              id: 0,
              label: "普通短信"
            },
            {
              id: 1,
              label: "富信"
            },
            {
              id: 2,
              label: "卡片短信"
            }
          ],
        },
        {
          name: "统计时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          valueFormat: "yyyy-MM-dd",
          type: "date",
        },
      ],
      changeColor: "#2062E7",
      /*
       * 统计时间
       * */
      /*
       * 统计表格
       * */
      countTable: [],
      sendDetailTotal: 0,
      currentPage: 1,
      showDetail: false,
      //时间选择框是否取消联动
      unlinkPanels: true,
      /*
       * 发送明细表格
       * */
      searchTime: [
        this.moment(month).format("YYYY-MM-DD HH:mm:ss"),
        this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      ],
      // countTime: [month, new Date()],
      countTime: [
        this.getDateStr(-30) + " 00:00:00",
        this.getDateStr(0) + " 23:59:59",
      ],
      sendDetail: [
        // "chinaMobileTotalNumber": "string",
        // "chinaTelecomTotalNumber": "string",
        // "chinaUnicomTotalNumber": "string",
        // "comfrom": "string",
        // "failTotalNumber": "string",
        // "sendTotalNumber": "string",
        // "smsTotalNumber": "string",
        // "statisticsTime": "string",
        // "subTotalNumber": "string"
      ],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "会员发送",
          label: "会员发送",
        },
        {
          value: "订单发送",
          label: "订单发送",
        },
        {
          value: "智能营销",
          label: "智能营销",
        },
        {
          value: "指定号码发送",
          label: "指定号码发送",
        },
        {
          value: "导入号码发送",
          label: "导入号码发送",
        },
        {
          value: "测试发送",
          label: "测试发送",
        },
        {
          value: "会员互动",
          label: "会员互动",
        },
        {
          value: "买家回复提醒",
          label: "买家回复提醒",
        },
        {
          value: "下单关怀",
          label: "下单关怀",
        },
        {
          value: "下单关怀(货到)",
          label: "下单关怀(货到)",
        },
        {
          value: "常规催付",
          label: "常规催付",
        },
        {
          value: "二次催付",
          label: "二次催付",
        },
        {
          value: "预售催付",
          label: "预售催付",
        },
        {
          value: "聚划算催付",
          label: "聚划算催付",
        },
        {
          value: "付款关怀",
          label: "付款关怀",
        },
        {
          value: "智能凑单",
          label: "智能凑单",
        },
        {
          value: "延迟发货",
          label: "延迟发货",
        },
        {
          value: "发货提醒",
          label: "发货提醒",
        },
        {
          value: "疑难件提醒",
          label: "疑难件提醒",
        },
        {
          value: "同城提醒",
          label: "同城提醒",
        },
        {
          value: "派件提醒",
          label: "派件提醒",
        },
        {
          value: "签收提醒",
          label: "签收提醒",
        },
        {
          value: "回款提醒",
          label: "回款提醒",
        },
        {
          value: "自动催评",
          label: "自动催评",
        },
        {
          value: "好评感谢",
          label: "好评感谢",
        },
        {
          value: "中差评安抚",
          label: "中差评安抚",
        },
        {
          value: "申请退款",
          label: "申请退款",
        },
        {
          value: "同意退款",
          label: "同意退款",
        },
        // {
        //   value: "派件提醒",
        //   label: "派件提醒"
        // },
        {
          value: "拒绝退款",
          label: "拒绝退款",
        },
        {
          value: "退款成功",
          label: "退款成功",
        },
        {
          value: "首购有礼",
          label: "首购有礼",
        },
        {
          value: "复购有礼",
          label: "复购有礼",
        },
        {
          value: "休眠提醒",
          label: "休眠提醒",
        },
        {
          value: "满月礼",
          label: "满月礼",
        },
        {
          value: "百日礼",
          label: "百日礼",
        },
        {
          value: "周年礼",
          label: "周年礼",
        },
        {
          value: "生日关怀",
          label: "生日关怀",
        },
        {
          value: "会员帐单",
          label: "会员帐单",
        },
        {
          value: "等级升级前提醒",
          label: "等级升级前提醒",
        },
        {
          value: "等级升级后提醒",
          label: "等级升级后提醒",
        },
        {
          value: "中差评管理",
          label: "中差评管理",
        },
        {
          value: "手动评价",
          label: "手动评价",
        },
        {
          value: "手动审核退款",
          label: "手动审核退款",
        },
        {
          value: "评价预警",
          label: "评价预警",
        },
        {
          value: "退款预警",
          label: "退款预警",
        },
      ],
      typeValue: "",
      typeValue2: "",
      postForm: {
        sendStartTime: this.getDateStr(-30) + " 00:00:00",
        sendEndTime: this.getDateStr(0) + " 23:59:59",
        sendStartTime2: "",
        sendEndTime2: "",
      },
      inputData1: [
        // 表单项
        {
          name: "统计时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          valueFormat: "yyyy-MM-dd",
          type: "date",
        },
      ],
      searchNum: {
        size: 10,
        current: 1,
        comfrom: "",
        smsType: "",
        startTime: this.getDateStr(-31),
        endTime: this.getDateStr(-1),
      },
      one: 1,
      aaa: 112,
      flag: false,


      // 
      visible: false,
      phone: "",
      phoneStr: "",
      code: "",
      timer: null, //验证码定时
      successMsg: "",
      countdown: 60, // 倒计时s
      codeMsg: "获取验证码", // 按钮上的文字
      saveDisable: false,
      codeDisabled: false,

      fileData: {},


    };
  },
  components: {
    inputForm,
    generate
  },
  mounted: function () {
    this.totalSearch();
  },
  created() {
    // 埋点
    this.buriedPoint(1, '短信账单', '后台管理', '短信管理')
    this.shortTypesNum();
  },
  methods: {
    async getphone() {
      this.control = true;
    },
    async  getphone1(val){
      console.log(val,'5555555');
       // 活动类型为精准营销
      let params = this.searchNum
      // params.code = this.code
      params.source = 3
      params.exportRemark = val
      let data = ""
      data = await getMessage_Zhangdang(params)
    },
    /** 获取验证码 */
    getCode() {
      if (!this.timer) {
        let parasm = { bindingPhone: this.phone, source: 2 }
        getSellerCheckCode(parasm).then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    async downloadFileMessage() {
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 活动类型为精准营销
      let params = this.searchNum
      params.code = this.code
      params.source = 3
      let data = ""
      data = await getMessage_Zhangdang(params)
      loading.close()

      if (data.code == 1) {
        var blob = new Blob([data.blob]);
        var link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "短信账单.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);

        this.visible = false
      } else {
        this.$message.warning(data.message);
      }
    },

    //

    //获取短信类型
    shortTypesNum() {
      var dataTypes = [];
      shortTypes({}).then((res) => {
        this.$nextTick(() => {
          var datas = JSON.parse(JSON.stringify(res.data));
          datas.unshift("全部");
          datas.forEach((v, index) => {
            var vote = {};
            vote.label = datas[index];
            vote.id = datas[index];
            if (vote.label === "全部") {
              vote.id = "";
            }
            dataTypes.push(vote); 23
          });
        });
        this.inputData[0].selectArr = dataTypes;
      });
    },
    //获取数据
    totalSearch() {
      // console.log(this.searchNum);

      this.defaultValue = [this.searchNum.startTime, this.searchNum.endTime];
      totalSearch(this.searchNum)
        .then((res) => {
          this.countTable = res.data;
        })
        .catch((err) => { });
    },
    //查询
    searchForm(value) {
      console.log("value:", value);
      this.searchNum.comfrom = value.status;
      this.searchNum.smsType = value.smsType;
      this.searchNum.startTime = value.startTime ? (value.startTime + ' 00:00:00') : "";
      this.searchNum.endTime = value.endTime ? (value.endTime + ' 23:59:59') : "";
      this.totalSearch();
    },
    /*
     * 查看发送明细事件
     * */
    handleCheck(index, row) {
      // val.orderStartTime=this.getDateStr(-30) + " 00:00:00",
      // val.orderEndTime=this.getDateStr(0) + " 23:59:59",
      // console.log(this.inputData1.orderStartTim);
      // console.log(this.getDateStr(-30) + " 00:00:00");
      // console.log(row)
      // console.log(this.inputData1);
      // console.log(this.searchNum);
      this.one = 1;
      this.typeValue2 = row.comfrom;
      this.showDetail = true;
      this.pageNum = 1;
      this.pageSize = 10;
      this.flag = true;
      this.viewSendDetail(1, row.billType, row.smsType);
      // this.searchFormOne()
      // this.inputData1[0].val[0]=this.getDateStr(-30) + " 00:00:00";
      //  this.inputData1[0].val.orderEndTime=this.getDateStr(0) + " 00:00:00";
      console.log(this.inputData1[0]);
    },
    //发送明细查询
    searchFormOne(val) {
      console.log(val)
      console.log('-----------')
      this.postForm.sendStartTime2 = val.startTime?(val.startTime.split(" ")[0] + " 00:00:00"):"";
      this.postForm.sendEndTime2 = val.endTime?(val.endTime.split(" ")[0] + " 23:59:59"):"";
      this.viewSendDetail();
    },
    viewSendDetail(pageNum, row, smsType) {
      // var pageNum = this.pageNum;
      if (this.flag) {
        // 弹窗第一次显示
        this.postForm.sendStartTime2 = this.searchNum.startTime;
        this.postForm.sendEndTime2 = this.searchNum.endTime;
        this.flag = false;
      }
      // if (this.postForm.sendStartTime2 == "") {
      //   this.postForm.sendStartTime2 = this.searchNum.startTime;
      //   this.postForm.sendEndTime2 = this.searchNum.endTime;
      // }
      var endTime = this.postForm.sendEndTime2 ? this.postForm.sendEndTime2 : ""
      var startTime = this.postForm.sendStartTime2 ? this.postForm.sendStartTime2 : ""

      this.tableLoading = true;
      sendDetail({
        comfrom: this.typeValue2,
        startTime: startTime,
        endTime: endTime,
        current: this.pageNum,
        size: this.pageSize,
        billType: row,
        smsType,
      }).then((res) => {
        this.tableLoading = false;
        (this.sendDetail = res.data.records),
          (this.sendDetailTotal = Number(res.data.total));
      });
    },
    sendDetailSearch() {
      this.pageNum = 1;
      this.viewSendDetail();
    },
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.viewSendDetail();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.viewSendDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }

  .form-box {
    padding-top: 16px;

    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;

      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }

      .item-value {
        display: inline-block;
      }
    }
  }

  .save-btn {
    text-align: center;
  }

  .backBtn {
    margin-left: 20px;
    width: 98px;
    height: 32px;
    color: #666666;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keepBtn {
    width: 98px;
    height: 32px;
    border-radius: 3px;
    background-color: #fe4d45;
    color: #fff;

    &:hover {
      opacity: 0.9;
    }
  }

}

/deep/.el-dialog__header span {
  width: 64px !important;
  height: 22px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  line-height: 28px !important;
  color: rgba(51, 51, 51, 1) !important;
  opacity: 1 !important;
}

/deep/.el-dialog {
  border-radius: 6px !important;
}

/deep/ .el-dialog .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid rgba(243, 243, 243, 1);
  opacity: 1;
  height: 54px;
  line-height: 54px;
  border-radius: 6px;
}

/deep/.el-dialog__body {
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 6px;
  padding: 30px 25px 30px 27px;
}

.titileDefinition {
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.operation {
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}

.section-right-content-box {
  //  margin-top: 10px;
  min-width: 1066px;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 26px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .search-box {
    height: 80px !important;

    .timePicker {
      vertical-align: middle;
      margin-right: 10px;
    }

    .button {
      vertical-align: middle;
    }
  }

  .headForm {
    margin-left: -20px;
  }
}

.show-detail-wrapper {
  .headForm {
    margin-left: -38px;
  }
}
</style>
